<template>
  <div>
    <!-- Header -->
    <el-row
      type="flex"
      :gutter="32"
      align="bottom"
      :style="{ flexWrap: 'wrap', marginBottom: '1rem' }"
    >
      <el-col :span="null" :style="{ flex: '1' }">
        <h1 :style="{ margin: '0' }">ทองลูกค้าขายฝาก</h1>
      </el-col>
      <el-col :span="null">
        <el-button type="primary" plain icon="el-icon-plus" @click="add"
          >เพิ่มรายการ</el-button
        >
      </el-col>
    </el-row>
    <!-- Content -->
    <el-card>
      <data-table
        :items="data"
        @update:items="update"
        @remove="remove"
        @totalAmountChange="handleTotalAmountChange"
      ></data-table>
    </el-card>
  </div>
</template>

<script>
const DataTable = () => import('../components/DataTable')

export default {
  components: { DataTable },

  props: {
    data: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    add() {
      this.$emit('update:data', [
        ...this.data,
        {
          name: '',
          percentage: null,
          weight: null,
          realWeight: null,
          amount: null,
          ceiling: null
        }
      ])
    },

    remove(index) {
      this.$emit(
        'update:data',
        this.data.filter((item, itemIndex) => itemIndex !== index)
      )
    },

    update(items) {
      this.$emit('update:data', items)
    },

    handleTotalAmountChange() {
      this.$emit('totalAmountChange')
    }
  }
}
</script>
